<div class="tcg-page">
  <ng-container *ngIf="pager$ | async as pager">
    <div class="tcg-table-toolbar">
      <span class="tcg-toolbar-title">Version History</span>
      <app-simple-pager
        [start]="pager.start"
        [end]="pager.end"
        [total]="pager.total"
        [disablePrev]="pager.disablePrev"
        [disableNext]="pager.disableNext"
        (prev)="prevPage()"
        (next)="nextPage()"
      ></app-simple-pager>
    </div>
  </ng-container>

  <div class="tcg-loading-wrapper" *ngIf="loading$ | async; else tableBlock">
    <app-loading [text]="'Loading data..'"></app-loading>
  </div>

  <ng-template #tableBlock>
    <app-zorro-table
      tableId="tcg-test-suites"
      class="w-100 tcg-table-view"
      [columns]="columns"
      [data]="(pagedSuites$ | async) ?? []"
      [options]="{ showPagination: false, pageSize: pageSize }"
      (handleActions)="onTableAction($event)"
    ></app-zorro-table>
  </ng-template>
</div>
